import { createSelector } from '@ngrx/store';

import { getCurrentLocationNo } from '@shared/state/currentLocation/selectors';
import { getCurrentMember } from '@shared/state/members/selectors';

export const getCurrentLocationNoWithMemberId = createSelector(getCurrentLocationNo, getCurrentMember, (locationNo, member) => ({
    locationNo,
    memberId: member?.MemberId || null,
}));
